import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../App.css"; // if you want to add custom styles
import ResumeP1 from "../images/ResumeP1.png";
import ResumeP2 from "../images/ResumeP2.png";
import JP_Resume2025 from "../images/JP_Resume2025.pdf";

export default function ResumePage() {
  return (
    <Container className="py-5 text-center">
      {/* Page Title */}
      <Row className="align-items-center mb-4">
        <Col md={8}>
          <h1 className="mb-2 resumeStyle">My Resume</h1>
          <h5 className="resumeStyle">Browse my resume below or download a PDF copy for offline viewing.</h5>
        </Col>
        <Col md={4} className="text-md-end mt-3 mt-md-0">
          <Button variant="primary" size="lg" onClick={() => window.open(JP_Resume2025, "_blank")}>
            Download Resume (PDF)
          </Button>
        </Col>
      </Row>
      {/* Resume Images */}
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <img
            src={ResumeP1}
            alt="Resume Page 1"
            className="img-fluid mb-4 shadow-sm rounded"
          />
        </Col>
        <Col md={10} lg={8}>
          <img
            src={ResumeP2}
            alt="Resume Page 2"
            className="img-fluid mb-5 shadow-sm rounded"
          />
        </Col>
      </Row>
    </Container>
  );
}